/**
 *
 * Teams Form
 *
 */

import React, { FC } from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiAddClientRequest } from '@ariksa/notification/api';
import { useDispatch } from 'react-redux';

import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';

import { actions } from '../../../../slice';

import { TeamsForm } from './TeamsForm';

export const CreateTeams: FC = () => {
  const { onCancel } = useIntegrations();
  const dispatch = useDispatch();

  const onSubmit = data => {
    const payload: ClientsApiAddClientRequest = {
      clientConfig: {
        client_name: Clients.Teams,
        name: data.name,
        status: true,
        teams: {
          webhook_url: data.webhook_url,
          channel_name: data.channel_name,
        },
      },
    };
    dispatch(actions.createClient({ q: payload, onSuccess: () => onCancel() }));
  };

  return <TeamsForm handleSubmit={onSubmit} />;
};
